import React, {memo} from 'react';
import {Carousel} from 'antd';
import HomeCarouselContent from './HomeCarouselContent';

// TODO: Quote, Footer

const carousels = [
  {
    key: 1,
    imagePath: `${process.env.PUBLIC_URL}/carousel-1.jpg`,
    actionText1: 'Best Creative Team',
    actionText2: 'With Smart Ideas',
    actionText3:
      'Consulto specially designed for Consulting and Finance industry, Financial Advisors, Accountants, Consultants or other Finance and Consulting related businesses.',
  },
  {
    key: 2,
    imagePath: `${process.env.PUBLIC_URL}/carousel-2.jpg`,
    actionText1: 'Qulity Is The Best',
    actionText2: 'Business Plan',
    actionText3:
      'Consulto specially designed for Consulting and Finance industry, Financial Advisors, Accountants, Consultants or other Finance and Consulting related businesses.',
  },
  {
    key: 3,
    imagePath: `${process.env.PUBLIC_URL}/carousel-3.jpg`,
    actionText1: null,
    actionText2: null,
    actionText3:
      'Consulto specially designed for Consulting and Finance industry, Financial Advisors, Accountants, Consultants or other Finance and Consulting related businesses.',
  },
];

const HomeCarousel = memo(() => {
  return (
    <Carousel autoplay fade infinite>
      {carousels.map((item) => (
        <HomeCarouselContent {...item} />
      ))}
    </Carousel>
  );
});

export default HomeCarousel;
